import { render, staticRenderFns } from "./VehicleCategory.vue?vue&type=template&id=61ec3b63&"
import script from "./VehicleCategory.vue?vue&type=script&lang=js&"
export * from "./VehicleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports